import styles from './Page404.module.css'
import CodeAblaze from '../../assets/CodeAblaze.png';

function Page404() {
  return (
    <div className={styles.Page404}>
      <div className={styles.CodeAblazeTitle}>
        <h1>
          404
          <br />
          Not Found
        </h1>
        <h2>
          Curious and intrigued by the unknown? Explore the wonders of coding by going to:<br />
          <a href="https://codeablazeprogram.wixsite.com/codeablaze">https://codeablazeprogram.wixsite.com/codeablaze</a>
        </h2>
      </div>

      <div className={styles.ContentDiv}>
        <div className={styles.ImageHolder}>
          <img src={CodeAblaze} alt="CodeAblaze Logo"
            onClick={() => {
              window.location.href = "https://codeablazeprogram.wixsite.com/codeablaze";
            }} />
        </div>
      </div>

      <h2 className={styles.HomepageLink}>
        Or visit our <a href="/">homepage</a>
      </h2>
    </div>
  );
}

export default Page404;
